import { FunctionComponent, lazy, Suspense, useEffect, useRef, useState } from "react";
import { CorpoTable, Tabela, TabelaCabeca, TabelaCorpo, Tabler } from "../../../../components/formulario/tableStyled";
import LoadingGif from "../../../../components/loading";
import { useServicesMembroBatismo } from "../context/getServices";
import styled from "styled-components";

const Rows = lazy(() => import('./rows'))

interface TabelaMembrosBatismoProps {}

const TabelaMembrosBatismo: FunctionComponent<TabelaMembrosBatismoProps> = () => {
  const { nextPagina } = useServicesMembroBatismo();
  const devRef = useRef<HTMLDivElement>(null);

  const [nomeOrder, setNomeOrder] = useState("");
  const [camisaFiltro, setCamisaFiltro] = useState("");

  useEffect(() => {
    if (devRef.current) {
      devRef.current.addEventListener('scroll', (e: any) => {
        if (e.target?.scrollTop >= (e.target.scrollHeight - (e.target.clientHeight + 60))) {
          nextPagina()
        }
      })
    }
  }, [devRef])

  return (
    <Tabler>
      <CorpoTable ref={devRef}>
        <Tabela>
          <TabelaCabeca>
            <tr>
              <th>
                <FiltroContainer>
                  <span>Nome</span>
                  <SelectFiltro onChange={(e) => setNomeOrder(e.target.value)} value={nomeOrder}>
                    <option value="">—</option>
                    <option value="asc">A-Z</option>
                    <option value="desc">Z-A</option>
                  </SelectFiltro>
                </FiltroContainer>
              </th>
              <th>Idade</th>
              <th>Email</th>
              <th>Telefone</th>
              <th>E. Cívil</th>
              <th>Evento</th>
              <th>
                <FiltroContainer>
                  <span>Camisa</span>
                  <SelectFiltro onChange={(e) => setCamisaFiltro(e.target.value)} value={camisaFiltro}>
                    <option value="">Todos</option>
                    <option value="PP">PP</option>
                    <option value="P">P</option>
                    <option value="M">M</option>
                    <option value="G">G</option>
                    <option value="GG">GG</option>
                  </SelectFiltro>
                </FiltroContainer>
              </th>
              <th>Inscrição</th>
              <th>Batismo</th>
              <th></th>
            </tr>
          </TabelaCabeca>
          <TabelaCorpo>
            <Suspense fallback={<LoadingGif />}>
              <Rows
                nomeOrder={nomeOrder}
                camisaFiltro={camisaFiltro}
              />
            </Suspense>
          </TabelaCorpo>
        </Tabela>
      </CorpoTable>
    </Tabler>
  );
}

export default TabelaMembrosBatismo;

// ✅ Estilo para o select
const SelectFiltro = styled.select`
  margin-left: 6px;
  padding: 2px 6px;
  border-radius: 6px;
  border: 1px solid #ccc;
  background-color: #f9f9f9;
  font-size: 0.85rem;
  outline: none;
  transition: all 0.2s ease;

  &:hover {
    border-color: #888;
  }

  &:focus {
    border-color: #117baa;
    background-color: #fff;
  }
`;

// ✅ Container flexível para alinhar título + select na horizontal
const FiltroContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-start;
  gap: 6px;
  white-space: nowrap;
`;
